import MUISwitch from '@mui/material/Switch';
import * as React from 'react';
import type { ReactNode } from 'react';

import Box from '~/common/components/Box';
import FormLabel from '~/common/components/FormLabel';

type SwitchProps = Readonly<{
  name?: string;
  id?: string;
  label?: ReactNode;
  disabled?: boolean;
  checked?: boolean;
  onChange?: (value: boolean) => void;
}>;
export default function Switch({
  name,
  id,
  label,
  disabled,
  onChange,
  checked,
  ...rest
}: SwitchProps) {
  const props = {
    name,
    id: id || name,
    disabled,
    checked,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) =>
      onChange(e.target.checked),
    inputProps: {
      'aria-labelledby': rest['aria-labelledby'],
    },
  };

  if (label) {
    return (
      <Box component="fieldset">
        <MUISwitch {...props} id={name} />
        <FormLabel
          htmlFor={props.id}
          label={label}
          disabled={disabled}
          sx={{ marginBottom: 'unset', fontWeight: 400 }}
        />
      </Box>
    );
  }

  return <MUISwitch {...props} />;
}
